<template>
  <el-tree
    :check-strictly="true"
    node-key="id"
    :props="props"
    :load="loadNode"
    @check-change="handleCheckChange"
    ref="dataTree"
    lazy
    show-checkbox
  >
  </el-tree>
</template>
<script>
import { getTissueTree } from "@/api/subcontractor-register";
export default {
  data() {
    return {
      company: "",
      parentOrgId: 1,
      treeData: [],
      props: {
        label: "useOrgName",
        children: "child",
        isLeaf: "leaf",
        disabled: "registerStatus",
      },
    };
  },
  methods: {
    //   展开时
    loadNode(node, resolve) {
      if (node.data && node.data.useOrgId) {
        this.parentOrgId = node.data.useOrgId;
      }
      getTissueTree({ parentOrgId: this.parentOrgId, flag: 1 }).then((res) => {
        if (res.data.code === "0" || res.data.code === 0) {
          //  if(node.level==2){
          //    res.data.data.forEach(item=>{
          //        item.leaf=true;
          //    })
          //  }
          if (!res.data.data || (res.data.data && res.data.data.length <= 0)) {
            return resolve([]);
          } else {
            res.data.data.forEach((e) => {
              e.registerStatus = e.registerStatus !== 0;
            });
            resolve(res.data.data);
          }
        }
      });
    },
    handleCheckChange(data, checked, indeterminate) {
      if (checked) {
        this.$refs.dataTree.setCheckedKeys([data.id]);
        this.company = data;
      }
    },
  },
};
</script>
